import { all } from 'redux-saga/effects';

import { changeGroupVisibilitySaga } from './changeGroupVisibility';
import { fetchGroupMembersSaga } from './fetchGroupMembers';
import { fetchGroupsSaga } from './fetchGroups';

export function* saga() {
    yield all([fetchGroupsSaga(), fetchGroupMembersSaga(), changeGroupVisibilitySaga()]);
}
